import { Config, ConfigProvider, Effect } from "effect";

const ClientConfig = Config.all({
  VITE_CONVEX_URL: Config.string("VITE_CONVEX_URL"),
  VITE_APP_ENV: Config.literal(
    "development",
    "preview",
    "production",
  )("VITE_APP_ENV").pipe(Config.withDefault("development" as const)),
});

export type ClientEnv = {
  readonly VITE_CONVEX_URL: string;
  readonly VITE_APP_ENV: "development" | "preview" | "production";
};

const provider: ConfigProvider.ConfigProvider = ConfigProvider.fromMap(
  new Map(
    Object.entries(import.meta.env).filter(([, v]) => typeof v === "string") as Array<
      [string, string]
    >,
  ),
);

export const env: ClientEnv = Effect.runSync(
  ClientConfig.pipe(Effect.withConfigProvider(provider)),
);
